import {
  EDIT_SYSTEM_USER_REQUEST,
  EDIT_SYSTEM_USER_SUCCESS,
  EDIT_SYSTEM_USER_FAILURE,
  EDIT_SYSTEM_USER_RESET,
} from '../../../redux/types/user';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: '',
};

const editSystemUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_SYSTEM_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: '',
      };

    case EDIT_SYSTEM_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || 'User role updated successfully',
      };

    case EDIT_SYSTEM_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || 'Something went wrong',
        success: false,
        message: '',
      };

    case EDIT_SYSTEM_USER_RESET:
      return { ...initialState };

    default:
      return state;
  }
};

export default editSystemUserReducer;
